import React, { useState } from "react";
import { Button, Form, Modal, Popconfirm } from "antd";
import FormFields from "./FormFields";
import CONSTANTS from "../../util/constant/CONSTANTS";

const ModalFormCreator = ({
  open,
  onCreate,
  Submit = true,
  onCancel,
  name = "",
  DeleteTitle,
  formData = {},
  menuFields,
  disabled = false,
  edit,
  changedFields = {},
  onChangedFields = () => { },
  SubmitName = "Create",
  onEdit = () => { },
  Delete,
  disableSubmit = true,
  onDelete = () => { },
  formFields = [],
  children,
  inbuilt = true,
  loading = false,
  formWidth = 1000,
}) => {
  const [defaultData, setDefaultData] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let fieldChangeData = {};

  const handleEdit = () => {
    if (CONSTANTS.USER_ROLE) {
      return;
    }
    onEdit();
  };

  const handleDelete = () => {
    if (CONSTANTS.USER_ROLE) {
      return;
    }
    onDelete();
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setDefaultData(values);
        Object.keys(fieldChangeData).forEach((key) => {
          if (formData[key] !== fieldChangeData[key]) {
            changedFields[key] = fieldChangeData[key];
          }
        });
        onCreate(values, () => {
          setDefaultData(null);
        });
        onChangedFields(changedFields);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleModalCancel = () => {
    setDefaultData(null);
    form.resetFields();
    onCancel();
  };

  const footer = {
    footer: [
      edit && (
        <Button
          key="edit"
          style={{
            borderRadius: "4px",
            height: "40px",
            width: "200px",
          }}
          disabled={CONSTANTS.USER_ROLE}
          ghost
          type="primary"
          onClick={handleEdit}
        >
          Edit
        </Button>
      ),
      Delete && (
        <Popconfirm
          onConfirm={handleDelete}
          key="deleteConfirm"
          disabled={CONSTANTS.USER_ROLE}
          title={`Delete ${DeleteTitle || name.toLowerCase()}`}
          description={`Are you sure to delete ${DeleteTitle || name.toLowerCase()
            }`}
        >
          <Button
            key="delete"
            style={{
              borderRadius: "4px",
              height: "40px",
              width: "200px",
            }}
            ghost
            type="primary"
            danger
          >
            Delete
          </Button>
        </Popconfirm>
      ),
      Submit && (
        <Button
          key="submit"
          disabled={CONSTANTS.USER_ROLE && disableSubmit}
          style={{
            borderRadius: "4px",
            height: "40px",
            width: "200px",
          }}
          type="primary"
          onClick={handleFormSubmit}
          loading={loading}
        >
          {SubmitName}
        </Button>
      ),
    ],
  };

  return (
    <Modal
      open={open}
      title={<p className="form-modal-head mb25">{name}</p>}
      okText="Submit"
      width={formWidth}
      {...footer}
      cancelButtonProps={{ style: { display: "none" } }}
      className="form-modal-title"
      onCancel={handleModalCancel}
      onOk={handleFormSubmit}
    >
      {inbuilt && (
        <FormFields
          formData={defaultData || formData}
          menuFields={menuFields}
          formFields={formFields}
          form={form}
          disabled={disabled}
          changedFields={fieldChangeData}
        />
      )}
      {children}
    </Modal>
  );
};

export default ModalFormCreator;

ModalFormCreator.defaultProps = {
  open: false,
  onCreate: () => { },
  onCancel: () => { },
  name: "",
  formData: {},
  menuFields: [],
  edit: false,
  onEdit: () => { },
  formFields: [],
};
